/* Existing LinkedIn base tag only. Blotout owns its separate server events. */
(function () {
  'use strict';

  var bootstrap = document.getElementById('fm-linkedin-insight-bootstrap');
  var consent = window.ShopifyConsent;
  var partnerId = '543313';
  var tagSource = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  var started = false;
  var checking = 0;

  if (!bootstrap || bootstrap.getAttribute('data-initialized') === 'true') return;
  bootstrap.setAttribute('data-initialized', 'true');

  function status(value) {
    bootstrap.setAttribute('data-status', value);
  }

  // Restrict URL metadata too: the vendor receives the page URL and referrer.
  // Permit genuine ad parameters; never read, fabricate or attach identity data.
  function publicUrl(value) {
    if (!value) return true;
    try {
      var url = new URL(value, window.location.origin);
      if (!/^https?:$/.test(url.protocol)) return false;
      if (/(?:^|\/)(?:account|accounts|cart|checkout|checkouts|orders|login|search)(?:\/|$)/i.test(url.pathname)) return false;
      if (/(?:contact|book.*demo|support|financ|payment|thank-you|password|reset|service-status)/i.test(url.pathname)) return false;
      if (/@|%40/i.test(url.href)) return false;
      if (url.hash && !/^#[a-z0-9_-]{1,80}$/i.test(url.hash)) return false;
      var safe = true;
      url.searchParams.forEach(function (value, key) {
        if (!/^(?:utm_(?:source|medium|campaign|content|term|id)|gclid|gbraid|wbraid|msclkid|fbclid|li_fat_id|gad_source|gad_campaignid|variant)$/i.test(key)) safe = false;
        if (value.length > 512 || /@/.test(value)) safe = false;
      });
      return safe;
    } catch (error) {
      return false;
    }
  }

  if (bootstrap.getAttribute('data-public-page') !== 'true' || !publicUrl(window.location.href) || !publicUrl(document.referrer)) {
    status('excluded-page');
    return;
  }
  if (!consent || typeof consent.getState !== 'function' || typeof consent.onConsentChange !== 'function') {
    status('privacy-unavailable');
    return;
  }

  function allowed(state) {
    var permissions = state && state.processingAllowed;
    return state && state.apiAvailable === true && permissions &&
      permissions.analytics === true && permissions.marketing === true &&
      permissions.saleOfData === true && navigator.globalPrivacyControl !== true;
  }

  function reconcile() {
    var request = ++checking;
    Promise.resolve().then(function () { return consent.getState(); }).then(function (state) {
      // A late result must not override a newer consent decision.
      if (request !== checking) return;
      if (!allowed(state)) {
        status('consent-blocked');
        if (started) {
          // Removing a script does not remove vendor listeners. A fresh document
          // is necessary to stop the already loaded runtime after withdrawal.
          window.location.reload();
        }
        return;
      }
      if (started) return;
      if (document.querySelector('script[src*="snap.licdn.com/li.lms-analytics/insight"]')) {
        started = true;
        status('existing-tag');
        return;
      }

      started = true;
      window._linkedin_partner_id = partnerId;
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      if (window._linkedin_data_partner_ids.indexOf(partnerId) === -1) window._linkedin_data_partner_ids.push(partnerId);
      if (!window.lintrk) {
        window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
        window.lintrk.q = [];
      }
      var tag = document.createElement('script');
      tag.id = 'fm-linkedin-insight';
      tag.async = true;
      tag.src = tagSource;
      tag.onload = function () { status('loaded'); };
      tag.onerror = function () { status('load-error'); };
      status('loading');
      document.head.appendChild(tag);
    }).catch(function () {
      if (request !== checking) return;
      status('privacy-unavailable');
      if (started) window.location.reload();
    });
  }

  status('checking-consent');
  consent.onConsentChange(reconcile);
  reconcile();
})();
